module.exports = __webpack_public_path__ + "static/media/asset1.2be0a4f6.svg";